import React, { useEffect, useState } from 'react'
import FlipCountdown from '@rumess/react-flip-countdown';
import { useSelector } from 'react-redux';

const CountDown = ({ lotteryContract }) => {
  const [windowSize, setWindowSize] = useState(undefined);
  const [size, setSize] = useState(undefined);
  const [endDate, setEndDate] = useState(0);

  const { connect } = useSelector(state => state.provider);
  const { friday, tuesday, both } = useSelector(state => state.lotteryDay);


  useEffect(() => {
    function handleResize() {
      setWindowSize(window.innerWidth);
    }
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => {
      window.removeEventListener('resize', handleResize);
    }
  }, []);
  useEffect(() => {
    if (windowSize < 768) {
      setSize('small');
    } else {
      setSize('medium');
    }
  }, [windowSize]);

  useEffect(() => {
    if (connect) {
      fetchDate();
    }
  }, [connect]);

  const fetchDate = async () => {
    const date = await lotteryContract.functions.lotteryEndTime();
    // console.log(new Date(date.toString() *1000).toISOString());
    // console.log(new Date(date.toString() *1000).toLocaleString());
    const dateFinal = new Date(date.toString() * 1000).toLocaleString().split(",")[0].replace("/", "-").replace("/", "-");
    const time = new Date(date.toString() * 1000).toLocaleString().split(",")[1];
    const a = dateFinal.split("-");
    // console.log(a);
    const b = a.reverse();
    // console.log(b);
    const c = b.join("-");
    // console.log(c+" "+time);
    setEndDate(c + " " + time);
  }
  return (
    <FlipCountdown
      hideYear
      hideMonth
      theme='dark'
      size={size}
      titlePosition='bottom'
      endAtZero
      endAt={endDate} // Date/Time
    />
  )
}

export default CountDown